import React from 'react'
import PropTypes from 'prop-types'

import CampaignPlaceholder from 'assets/images/campaign/campaign_image_400x400-1.png'
import styles from './styles.scss'

const renderPriceGuide = ({ sold, price_guide }) => {
  let string = 'Undisclosed'

  if (price_guide) string = price_guide
  if (sold) string = `Sold ${string}`

  return string
}

const Comparable = (props) => {
  const { campaignComparable } = props
  const {
    address, bathrooms, bedrooms, carparks, default_image, suburb_name,
  } = campaignComparable

  return (
    <div className={styles.root}>
      <span className={styles.image} style={{ backgroundImage: default_image ? `url(${default_image})` : `url(${CampaignPlaceholder})` }} />
      <div className={styles.details}>
        <span className={styles.price}>{renderPriceGuide(campaignComparable)}</span>
        <span className={styles.address}>
          {address}, {suburb_name}
        </span>
        <span className={styles.attributes}>
          {bedrooms && `${bedrooms} Bed `}
          {bathrooms && `${bathrooms} Bath `}
          {carparks && `${carparks} Car`}
        </span>
      </div>
    </div>
  )
}

Comparable.propTypes = {
  campaignComparable: PropTypes.object.isRequired,
}

export default Comparable
